import { FunnelIcon, XMarkIcon } from "@heroicons/react/24/outline"
import { classNames, classNamesOrEmpty } from "../../style/common"
import { useState } from "react"

export type DescriptionListItem = {
    label: string,
    value: string,
    onClick: (activate: boolean) => void,
    isActive: boolean
}

export type DescriptionListProps = {
    title: string,
    noItemsMessage?: string,
    items: DescriptionListItem[],
    classNames?: {
        container?: string | undefined,
        title?: string | undefined,
        value?: string | undefined,
        label?: string | undefined
    }
}

export default function DescriptionFilterList(props: DescriptionListProps) {
    return (
        <div className={classNames(
            "overflow-hidden rounded-xl border border-color-border flex text-contrast-primary flex-col select-none",
            props.classNames?.container
        )}>
            <div className="flex items-center gap-x-4 border-b border-color-border bg-tertiary py-1 px-3">
                <div className="text-sm font-medium leading-6">{props.title}</div>
            </div>
            {
                (props.items.length > 0 || !props.noItemsMessage)
                    ? <dl className="-my-3 divide-y divide-tertiary px-3 py-4 text-sm leading-6">
                        {
                            props.items.map((item, index) => (
                                <DescriptionFilterListItem key={index} item={item} classNames={props.classNames} />
                            ))
                        }
                    </dl>
                    : <div className={`flex flex-1 items-center justify-center text-sm leading-6 ${classNamesOrEmpty(props.classNames?.label)}`}>
                        <span>{props.noItemsMessage}</span>
                    </div>
            }
        </div>
    )
}

type DescriptionFilterListItemProps = {
    item: DescriptionListItem,
    classNames?: {
        container?: string | undefined,
        title?: string | undefined,
        value?: string | undefined,
        label?: string | undefined
    }
}

function DescriptionFilterListItem(props: DescriptionFilterListItemProps) {
    const [isHovered, setIsHovered] = useState<boolean>(false);

    return (
        <div
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            onClick={() => props.item.onClick(!props.item.isActive)}
            className={classNames(
                "flex justify-between gap-x-4 cursor-pointer w-full",
                !props.item.isActive && "hover:text-contrast-tertiary",
                props.item.isActive && "text-emphasis hover:text-error-contrast"
            )}
        >
            <div className="flex gap-2 items-center">
                {
                    ((!props.item.isActive && isHovered) || (props.item.isActive && !isHovered)) && <FunnelIcon className="h-4 w-4" />
                }
                {
                    (props.item.isActive && isHovered) && <XMarkIcon className="h-4 w-4" />
                }
                <dt
                    className={classNames(
                        props.classNames?.label
                    )}
                >
                    {props.item.label}
                </dt>
            </div>
            <dd className={classNames(props.classNames?.value)}>
                {props.item.value}
            </dd>
        </div>
    )
}